var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TeacherResource"},[_c('div',{staticClass:"resource-detail-block"},[_c('resource-detail',{attrs:{"show":_vm.detailShow,"detailData":_vm.detailData,"detailType":"3","examineStatus":_vm.menuStatus},on:{"onReturn":function($event){_vm.detailShow = false},"toEdit":_vm.toEdit}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }